import WMTSClass, * as WMTSModule from './../../node_modules/ol/source/WMTS.js';

class WMTS extends WMTSClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in WMTSModule) {
    if (key !== "default") {
        WMTS[key] = WMTSModule[key];
    }
}

export default WMTS;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/WMTS.js';